import React from 'react';
import Rail from '@dazn/lp-web/src/components/Rail/Rail';
import {IComingUpRail} from '@dazn/lp-web/src/types';

interface IComingUpRailProps {
    data: IComingUpRail;
    key: number;
    disableAnimation: boolean;
}

const ComingUpRail: React.FC<IComingUpRailProps> = ({
    data,
    disableAnimation
}) => {
    return (
        <Rail
            key={data.railType}
            rail={data}
            disableAnimation={disableAnimation}
        />
    );
};

export default ComingUpRail;
